import { PRODUCT_TYPE_SCHEMA, PRODUCT_TYPES } from '@schuettflix/interfaces';

export const TRANSPORT_PRODUCT_TYPES_SCHEMA = PRODUCT_TYPE_SCHEMA.extract(['TRANSPORT', 'CUSTOM_TRANSPORT']);

export function isTransportProduct(productType: PRODUCT_TYPES) {
    return TRANSPORT_PRODUCT_TYPES_SCHEMA.safeParse(productType).success;
}
